import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  endTime: string;
};
export type CheckValidExtensionResponse = {};

export const useCheckValidExtension = createMutation<
  CheckValidExtensionResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/check-valid-extension`,
      method: 'POST',
      data: {
        end_time: variables.endTime,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
